import {DateUtils} from '@/utils/DateUtils';

export const UPDATE_TIME_IN_MS = DateUtils.secondsToMilliseconds(0.5);
